/* ==========================================================================
# Collection Selector
========================================================================== */

// MB: Function to find the chevrons
function findIconChevron(element) {
  // MB: Check if element is null or undefined
  if (!element) {
    return null;
  }

  let sibling = element.parentNode.firstChild;
  while (sibling) {
    if (
      sibling.nodeType === 1 &&
      sibling.classList.contains("js-icon-chevron")
    ) {
      return sibling;
    }
    sibling = sibling.nextSibling;
  }
  return null;
}

function syncAriaExpanded(triggerSelector, optionsSelector) {
  const trigger = document.querySelector(triggerSelector);
  const options = document.querySelector(optionsSelector);

  if (trigger && options) {
    trigger.setAttribute("aria-expanded", options.classList.contains("hidden") ? "false" : "true");

    const observer = new MutationObserver(() => {
      trigger.setAttribute("aria-expanded", options.classList.contains("hidden") ? "false" : "true");
    });

    observer.observe(options, { attributes: true, attributeFilter: ["class"] });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  syncAriaExpanded(".js-shopping-for-option", ".js-shopping-for-options");
  syncAriaExpanded(".js-looking-for-option", ".js-looking-for-options");
});

function getDropdownElements(type) {
  const option = document.querySelector(`.js-${type}-for-option`);
  const options = document.querySelector(`.js-${type}-for-options`);
  const iconChevron = findIconChevron(option);
  return { option, options, iconChevron };
}

// Keyboard support for dropdown menus
function openDropdown(type) {
  const otherType = type === "shopping" ? "looking" : "shopping";
  const { options, iconChevron } = getDropdownElements(type);
  const { options: otherOptions, iconChevron: otherChevron } = getDropdownElements(otherType);

  if(otherOptions) {
    otherOptions.classList.remove("flex");
    otherOptions.classList.add("hidden");
    if (otherChevron) otherChevron.classList.remove("rotate-180");
  }

  if(options) {
    options.classList.remove("hidden");
    options.classList.add("flex");
    if (iconChevron) iconChevron.classList.add("rotate-180");
  }
}

function closeDropdownsIfOutside(e) {
  ["shopping", "looking"].forEach(type => {
    const { option, options, iconChevron } = getDropdownElements(type);
    if (
      options &&
      !e.target.closest(`.js-${type}-for-option`) &&
      !e.target.closest(`.js-${type}-for-options`)
    ) {
      options.classList.remove("flex");
      options.classList.add("hidden");
      if (iconChevron) iconChevron.classList.remove("rotate-180");
    }
  });
}

["shopping", "looking"].forEach(type => {
  const { option } = getDropdownElements(type);
  if (option) {
    option.addEventListener("click", () => openDropdown(type));
    option.addEventListener("focus", () => openDropdown(type));
  }
});

window.addEventListener("click", closeDropdownsIfOutside);
window.addEventListener("focusin", closeDropdownsIfOutside);

// MB: Function to handle click on .js-shopping-options--item
document.querySelectorAll(".js-shopping-options--item").forEach((item) => {
  item.addEventListener("click", () => handleShoppingOptionClick.bind(item)());
  item.addEventListener(
    "keydown",
    (event) => event.code === "Enter" && handleShoppingOptionClick.bind(item)(),
  );
});

function handleShoppingOptionClick() {
  const selectedShoppingOption = this.textContent.trim();
  const shoppingForOption = document.querySelector(".js-shopping-for-option");
  const iconChevron = findIconChevron(shoppingForOption);
  const iconChevronCode =
    '<span class="js-icon-chevron flex w-4 h-4 transition--all duration-300 ease-in-out mt-0 group-hover/shop-opton:mt-1 group-hover/shop-option:text-gold"><svg xlmns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M1 1L5 5L9 1" stroke="currentColor"></path></svg></span>';

  if (shoppingForOption) {
    shoppingForOption.textContent = selectedShoppingOption;
    // append iconChevronCode to shoppingForOption
    shoppingForOption.innerHTML = selectedShoppingOption + iconChevronCode;
  }

  const shoppingForOptions = document.querySelector(".js-shopping-for-options");

  if (shoppingForOptions) {
    shoppingForOptions.classList.remove("flex");
    shoppingForOptions.classList.add("hidden");
  }

  document.querySelectorAll(".js-shopping-options--item").forEach((option) => {
    option.classList.remove("!text-gold", "font-semibold");
    const checkedOption = option.querySelector(".js-selected-item");

    if (checkedOption) {
      checkedOption.classList.add("hidden");
      checkedOption.classList.remove("flex");
    }
  });

  this.classList.add("!text-gold", "font-semibold");
  const checkedOption = this.querySelector(".js-selected-item");

  if (checkedOption) {
    checkedOption.classList.remove("hidden");
    checkedOption.classList.add("flex");
  }

  // MB: Remove rotate-180 class from the chevron associated with shoppingForOption
  if (iconChevron) {
    iconChevron.classList.remove("rotate-180");
  }

  updateResultButtonHref();
}

// MB: Function to handle click on .js-looking-options--item
document.querySelectorAll(".js-looking-options--item").forEach((item) => {
  item.addEventListener("click", () => handleLookingOptionClick.bind(item)());
  item.addEventListener(
    "keydown",
    (event) => event.code === "Enter" && handleLookingOptionClick.bind(item)(),
  );
});

function handleLookingOptionClick() {
  const selectedLookingOption = this.textContent.trim();
  const lookingForOption = document.querySelector(".js-looking-for-option");
  const iconChevron = findIconChevron(lookingForOption);
  const iconChevronCode =
    '<span class="js-icon-chevron flex w-4 h-4 transition--all duration-300 ease-in-out mt-0 group-hover/shop-opton:mt-1 group-hover/shop-option:text-gold"><svg xlmns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M1 1L5 5L9 1" stroke="currentColor"></path></svg></span>';

  if (lookingForOption) {
    lookingForOption.textContent = selectedLookingOption;
    lookingForOption.innerHTML = selectedLookingOption + iconChevronCode;
  }

  const lookingForOptions = document.querySelector(".js-looking-for-options");

  if (lookingForOptions) {
    lookingForOptions.classList.remove("flex");
    lookingForOptions.classList.add("hidden");
  }

  document.querySelectorAll(".js-looking-options--item").forEach((option) => {
    option.classList.remove("!text-gold", "font-semibold");
    const checkedOption = option.querySelector(".js-selected-item");

    if (checkedOption) {
      checkedOption.classList.add("hidden");
      checkedOption.classList.remove("flex");
    }
  });

  this.classList.add("!text-gold", "font-semibold");
  const checkedOption = this.querySelector(".js-selected-item");

  if (checkedOption) {
    checkedOption.classList.remove("hidden");
    checkedOption.classList.add("flex");
  }

  // MB: Remove rotate-180 class from the chevron associated with lookingForOption
  if (iconChevron) {
    iconChevron.classList.remove("rotate-180");
  }

  updateResultButtonHref();
}

// MB: Function to update .js-result-button href based on conditions
function updateResultButtonHref() {
  const shoppingForAttr = document
    .querySelector(".js-shopping-for-option")
    ?.textContent.trim();
  const lookingForAttr = document
    .querySelector(".js-looking-for-option")
    ?.textContent.trim();
  const resultButton = document.querySelector(".js-result-button");
  const matchingItem = document.querySelector(
    `.js-result-url[data-shopping-for="${shoppingForAttr?.toLowerCase()}"][data-looking-for="${lookingForAttr?.toLowerCase()}"]`
  );

  if (resultButton && matchingItem) {
    const resultUrl = matchingItem.value;
    const resultButtonText = matchingItem.getAttribute("data-cta-text");
    resultButton.setAttribute("href", resultUrl);
    resultButton.childNodes[0].nodeValue = resultButtonText;
    resultButton.classList.remove("hidden");
  } else if (resultButton) {
    resultButton.removeAttribute("href");
    resultButton.classList.add("hidden");
  }
}

// MB: Check on initial load for matching text content for the 'shopping' section
window.addEventListener("DOMContentLoaded", () => {
  const shoppingForOptionText = document
    .querySelector(".js-shopping-for-option")
    ?.textContent.trim();
  const shoppingOptionsItems = document.querySelectorAll(
    ".js-shopping-options--item"
  );

  if (shoppingOptionsItems) {
    shoppingOptionsItems.forEach((option) => {
      const checkedOption = option.querySelector(".js-selected-item");

      if (
        checkedOption &&
        option.textContent.trim() === shoppingForOptionText
      ) {
        option.classList.add("!text-gold", "font-semibold");
        checkedOption.classList.remove("hidden");
        checkedOption.classList.add("flex");
      } else if (checkedOption) {
        checkedOption.classList.add("hidden");
        checkedOption.classList.remove("flex");
      }
    });
  }
});

// MB: Check on initial load for matching text content for the 'looking' section
window.addEventListener("DOMContentLoaded", () => {
  const lookingForOptionText = document
    .querySelector(".js-looking-for-option")
    ?.textContent.trim();
  const lookingOptionsItems = document.querySelectorAll(
    ".js-looking-options--item"
  );

  if (lookingOptionsItems) {
    lookingOptionsItems.forEach((option) => {
      const checkedOption = option.querySelector(".js-selected-item");

      if (checkedOption && option.textContent.trim() === lookingForOptionText) {
        option.classList.add("!text-gold", "font-semibold");
        checkedOption.classList.remove("hidden");
        checkedOption.classList.add("flex");
      } else if (checkedOption) {
        checkedOption.classList.add("hidden");
        checkedOption.classList.remove("flex");
      }
    });
  }
});
